// extracted by mini-css-extract-plugin
export default {"ourWorkItemImg":"OurWorkItem_ourWorkItemImg__2hkYx","ourWorkItemTitle":"OurWorkItem_ourWorkItemTitle__7gZCy","ourWorkItemText":"OurWorkItem_ourWorkItemText__JD4+N"};